module.exports = __webpack_public_path__ + "static/media/ips-share.8ae63d4d.svg";